import { isInIframe } from './url-utils';
import React, { useEffect, useRef } from 'react';
import useResizeObserver from '@react-hook/resize-observer';

export function DynamicIframe(props: any) {
  const container = useRef(null);
  const lastHeight = useRef(0);

  const resize = (rect: any) => {
    console.log('resize app window');
    const height = rect.height + 25;
    const newHeight = height < 300 ? 300 : height;
    if (Math.abs(lastHeight.current - newHeight) > 20) {
      lastHeight.current = newHeight;
      //console.log('send message:' + newHeight);
      window.parent.postMessage({
                                  height: newHeight,
                                  href: window.location.href
                                }, '*');
    }
  };

  useResizeObserver(container, entry => resize(entry.contentRect));

  useEffect(
    () => {
        //console.log(isInIframe());
      if (isInIframe() && !lastHeight.current) {
        resize({ width: 1000, height: (container as any).current.clientHeight });
      }
    },
    [resize]
  );

  return <div ref={container}>
    {props.children}
  </div>;
}
